import { apiRequest } from "@core/services/api/apiRequest";
import { getTrackingMetadata } from "@core/features/videoMeeting";

/**
 * Fire-and-forget error reporter for video room issues.
 * Posts to the backend log-error endpoint so failures are visible
 * in the admin Status Console.
 */
export async function logVideoRoomError(
  errorMessage: string,
  errorType: string,
  additionalData?: Record<string, unknown>,
  context?: { roomId?: number | string | null; user?: { id: number } | null }
): Promise<void> {
  try {
    const effectiveRoomId =
      context?.roomId ||
      new URLSearchParams(window.location.search).get("room_id") ||
      "1";

    const trackingMetadata = getTrackingMetadata(context?.user ?? null);

    await apiRequest("/api/video-room/log-error/", "POST", {
      room_id: effectiveRoomId,
      error_message: errorMessage,
      error_type: errorType,
      additional_data: additionalData,
      ...trackingMetadata,
    });
  } catch {
    // Non-fatal: error logging API call failed
  }
}
